import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { DotIcon } from '@/ui/Icons/DotIcon';

export function MatchaAutoSwitchOff() {
  return (
    <ul className="w-full mt-2">
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <DotIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-gray-600" />
        Network fees
      </li>
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        Set gas fee
        <span className="text-token-gray-700 before:content-['·'] before:mx-1 before:text-token-gray-1200">
          Trade may fail if set too low
        </span>
      </li>
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        Set slippage
        <span className="text-token-gray-700 before:content-['·'] before:mx-1 before:text-token-gray-1200">
          Slippage Protection enabled
        </span>
      </li>
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        <span>130+ liquidity sources</span>
        <span className="text-token-gray-700 before:content-['·'] before:mx-1 before:text-token-gray-1200">
          Select from list
        </span>
      </li>
      <li className="relative mt-[10px] pb-0 text-token-gray-900 text-350 font-medium leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        Smart Routing
        <span className="text-token-gray-700 before:content-['·'] before:mx-1 before:text-token-gray-1200">
          Auto
        </span>
      </li>
    </ul>
  );
}
